'use client';

import { useState } from 'react';
import { Box, Tab, Tabs, IconButton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MasterFuelPricePage from './MasterFuelPricePage';
import FuelPriceHistoryPage from './FuelPriceHistoryPage';
import InformationBubbleDialog from '../../../components/InformationBubbleDialog';
import { useLanguage } from '../../../utils/i18n';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`fuel-tabpanel-${index}`}
      aria-labelledby={`fuel-tab-${index}`}
      {...other}
      style={{ minHeight: 'calc(100vh - 200px)' }}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `fuel-tab-${index}`,
    'aria-controls': `fuel-tabpanel-${index}`
  };
}

const HeaderFuelPrice = () => {
  const { t } = useLanguage();
  const [tabValue, setTabValue] = useState(0);
  const [infoOpen, setInfoOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const infoMessages = [
    {
      type: 'q',
      text: t('fuelPriceInfo.q1', 'What is the difference between Master Fuel Price and Fuel Price History?')
    },
    {
      type: 'a',
      text: t(
        'fuelPriceInfo.a1',
        'Master Fuel Price is used to configure and store base fuel prices by Fuel Type for the company, effective from the specified "Valid At" date.'
      )
    },
    {
      type: 'q',
      text: t('fuelPriceInfo.q2', 'What is the purpose of Fuel Price History?')
    },
    {
      type: 'a',
      text: t(
        'fuelPriceInfo.a2',
        'Fuel Price History is used to assign specific fuel prices to individual vehicles. You can use Batch mode to assign prices to multiple vehicles at once. This ensures reporting systems calculate fuel consumption costs using accurate historical prices for each period.'
      )
    }
  ];

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="Fuel Price Tabs" sx={{ flexGrow: 1 }}>
          <Tab label={t('menu.masterFuelPrice', 'Fuel Price')} {...a11yProps(0)} />
          <Tab label={t('menu.fuelPriceHistory', 'Fuel Price History')} {...a11yProps(1)} />
        </Tabs>

        <Tooltip title={t('general.information', 'Information')}>
          <IconButton onClick={() => setInfoOpen(true)} color="primary" sx={{ mr: 2 }}>
            <InfoOutlinedIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <MasterFuelPricePage />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <FuelPriceHistoryPage />
      </TabPanel>

      <InformationBubbleDialog
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        title={t('menu.fuelPrice', 'Fuel Price Information')}
        messages={infoMessages}
      />
    </Box>
  );
};

export default HeaderFuelPrice;
